import { authenticatedFetch } from './authenticated-fetch.js';

export interface TtvCohortRow {
  cohortMonth: string;
  businessType: string;
  metric: string;
  n: number;
  p50Days: number | null;
  p75Days: number | null;
  /** ADR-0111 activation north-star; populated only for the `activated_14d` metric. */
  shareValue: number | null;
  runId: string;
  computedAt: string;
}

export async function fetchTtvTrend(
  metric: string,
): Promise<{ metric: string; cohorts: TtvCohortRow[] }> {
  const res = await authenticatedFetch(`/api/onboarding/metrics/ttv/${metric}`);
  if (!res.ok) throw new Error(`fetchTtvTrend failed: ${res.status}`);
  return res.json();
}

export interface StepStatusRow {
  stepKey: string;
  status: string;
  count: number;
}

export async function fetchStepStatus(): Promise<{ steps: StepStatusRow[] }> {
  const res = await authenticatedFetch('/api/onboarding/metrics/step-status');
  if (!res.ok) throw new Error(`fetchStepStatus failed: ${res.status}`);
  return res.json();
}

export interface StuckTenantRow {
  tenantId: string;
  businessName: string;
  businessType: string;
  daysSinceCreated: number;
  reasonCodes: Array<'no_first_sale' | 'stalled_pre_live'>;
  stalledSince: string | null;
  blockedStepKey: string | null;
  lastActivityAt: string | null;
  firstSaleAt: string | null;
}

export async function fetchStuckTenantWorklist(params: {
  cursor: string | null;
  limit: number;
}): Promise<{ tenants: StuckTenantRow[]; nextCursor: string | null }> {
  const qs = new URLSearchParams({
    limit: String(params.limit),
    ...(params.cursor ? { cursor: params.cursor } : {}),
  });
  const res = await authenticatedFetch(`/api/onboarding/metrics/worklist/stuck-tenants?${qs}`);
  if (!res.ok) throw new Error(`fetchStuckTenantWorklist failed: ${res.status}`);
  return res.json();
}
